export const SENDING_REQUEST = 'PERMISSIONPICKER_SENDING_REQUEST';
export const GET_PERMISSION_GROUPS_SUCCESS = 'PERMISSIONPICKER_GET_PERMISSION_GROUPS_SUCCESS';
export const FAILURE = 'PERMISSIONPICKER_FAILURE';
export const RESET_FORM = 'PERMISSIONPICKER_RESET_FORM';